import { useEffect, useRef, useState, useContext } from 'react'
import { Helmet } from "react-helmet";
import "./Prenota.css"
import Informazioni from "./componenti/Informazioni"
import { Account } from "./Main"
import { calcola_diff_giorni, annoBisestile, debug_mode, fetchWithAuth } from "./Utils"
import campo1 from "./img/campo1.jpg"
import campo2 from "./img/touch.jpeg"
import campo3 from "./img/campo2.jpg"
import InputSelect from './componenti/InputSelect'
import Popup from './componenti/Popup'

const Prenotazione = class {
    constructor(id, idCampo, idUtente, data, ora, start, end, timestamp, fascia, giocatore2, giocatore3, giocatore4, inagibile, nome, cognome, username, nomeCampo, puo_cancellare) {
        this.id = id;
        this.idCampo = idCampo;
        this.idUtente = idUtente;
        this.data = data;
        this.ora = ora;
        this.start = start;
        this.end = end;
        this.timestamp = timestamp;
        this.fascia = fascia;
        this.giocatore2 = giocatore2;
        this.giocatore3 = giocatore3;
        this.giocatore4 = giocatore4;
        this.inagibile = inagibile;
        this.nome = nome;
        this.cognome = cognome;
        this.username = username;
        this.nomeCampo = nomeCampo;
        this.puo_cancellare = puo_cancellare;
    }
};

const Giorno = class {
    constructor(
        id,
        data,
        ora,
        start,
        end,
        fascia,
        username,
        inagibile,
        nome,
        cognome,
        giornoStringa,
        disabled = false
    ) {
        this.id = id;
        this.data = data;
        this.ora = ora;
        this.start = start;
        this.end = end;
        this.fascia = fascia;
        this.username = username;
        this.inagibile = inagibile;
        this.nome = nome;
        this.cognome = cognome;
        this.giornoStringa = giornoStringa;
        this.disabled = disabled;
    }
};

const Prenota = () => {
    const utente_user = useContext(Account);
    const { showAlert } = useContext(Account);

    // Costanti
    const mesi = [
        { nome_mese: 'Gennaio', numero_giorni: 31 },
        { nome_mese: 'Febbraio', numero_giorni: 28 },
        { nome_mese: 'Marzo', numero_giorni: 31 },
        { nome_mese: 'Aprile', numero_giorni: 30 },
        { nome_mese: 'Maggio', numero_giorni: 31 },
        { nome_mese: 'Giugno', numero_giorni: 30 },
        { nome_mese: 'Luglio', numero_giorni: 31 },
        { nome_mese: 'Agosto', numero_giorni: 31 },
        { nome_mese: 'Settembre', numero_giorni: 30 },
        { nome_mese: 'Ottobre', numero_giorni: 31 },
        { nome_mese: 'Novembre', numero_giorni: 30 },
        { nome_mese: 'Dicembre', numero_giorni: 31 }
    ]
    const nomi_giorni = ["lun", "mar", "mer", "gio", "ven", "sab", "dom"];

    // Stato
    const data_oggi = new Date();
    // const data_oggi = new Date("2025-12-25");
    const [caricato, setcaricato] = useState(true);
    const [orari, setorari] = useState([]);
    const [campi, setcampi] = useState([]);
    const [giorniTitoli, setgiorniTitoli] = useState([]);
    const [giorniTabella, setgiorniTabella] = useState([]);
    const [prenotazioniPopup, setprenotazioniPopup] = useState([]);
    const [prenotazioni, setPrenotazioni] = useState([]);
    const [giornoSelezionato, setGiornoSelezionato] = useState(null);
    const [caricamentoUtente, setCaricamentoUtente] = useState(false);
    const [player, setPlayer] = useState("");
    const [campo, setCampo] = useState("");
    const [usernames_players_list, set_usernames_players_list] = useState([]);

    const [info_giorni_stringa, set_info_giorni_stringa] = useState([]);
    const [info_mesi_numero, set_info_mesi_numero] = useState([]);
    const [info_ore_stringa, set_info_ore_stringa] = useState([]);
    const [info_anni, set_info_anni] = useState([]);

    const [filtroPrenotazioni, setFiltroPrenotazioni] = useState("");

    // Ref
    const inputPlayer = useRef(null);
    const ospite = useRef(null);
    const NoAccesso = useRef(null);

    // Variabili di configurazione
    let num_giorni_visualizzati = utente_user.persona.maestro ? 21 : (utente_user.persona.socio ? 14 : 7);

    useEffect(() => {
        if (utente_user.persona.username === "")
            setCaricamentoUtente(true)
        else
            setCaricamentoUtente(false);
    }, [utente_user.persona]);

    useEffect(() => {
        if (giornoSelezionato) {
            controllaPrenotazioniEGiorno(giornoSelezionato)
        }
    }, [giornoSelezionato])

    useEffect(() => {
        mostraPrenotazioniPopup(prenotazioni);
    }, [filtroPrenotazioni]);

    useEffect(() => {
        document.body.scrollTop = 0;

        // Controllo anno bisestile
        if (annoBisestile(data_oggi.getFullYear()))
            mesi[1].numero_giorni = 29;

        scaricaUserName();
        if (localStorage.getItem("access_token") !== null) {
            if (NoAccesso.current) NoAccesso.current.style.display = "none"
            crea_campi()
            if (!utente_user.persona.maestro) {
                document.querySelector("#tutte_pren").style.display = "none"
            }
        } else {
            document.querySelector("#sceltaCampi").style.display = "none"
            document.querySelectorAll(".chiuso").forEach((c) => {
                c.style.display = "none"
            })
        }
    }, []);

    useEffect(() => {
        processaGiorniTabella({ n: num_giorni_visualizzati, num_orari: orari.length + 1 });
    }, [prenotazioni, campo]);

    const scaricaUserName = async () => {
        try {
            const data = await fetchWithAuth("visualizza_utenti.php", {}, "GET");
            let usernames = data.utenti.sort((a, b) => (a.username > b.username ? 1 : -1));
            set_usernames_players_list(
                usernames.filter(
                    (x) =>
                        x.username !== utente_user.persona.username &&
                        x.username !== "campo.inagibile"
                )
            );
        } catch (error) {
            console.error("Errore nel caricamento utenti:", error);
            showAlert("Attenzione", "Errore nel caricamento utenti");
        }
    }

    const formattaOra = (ora) => {
        if (!ora.includes(":")) {
            // caso "7"
            return ora.padStart(2, "0") + ":00";
        } else {
            // caso "7:30"
            let [h, m] = ora.split(":");
            return h.padStart(2, "0") + ":" + m;
        }
    };

    const formattaData = (giorno, mese, anno) => {
        return `${String(giorno).padStart(2, "0")}/${String(mese).padStart(2, "0")}/${anno}`;
    };

    // #region CAMPI

    const crea_campi = () => {
        fetchWithAuth("visualizza_campi.php", {}, "GET")
            .then(function (data) {
                setcampi([])
                var campi_foto = [campo1, campo2, campo3]
                var campi_nomi = ["Campo 1", "Touchtennis", "Campo 2"]
                data.campi.forEach((cp, cont) => {
                    if (campi_foto[cont] === null) campi_foto[cont] = campi_foto[0]
                    if (campi_nomi[cont] === null) campi_nomi[cont] = "Campo"
                    let el = <span key={campi_nomi[cont]} data-nome={campi_nomi[cont]}><img src={campi_foto[cont]} className="imgcampo" id={cont} alt={cp.nome} onClick={selezionaCampo} /></span>
                    if (cont === 0) {
                        el = <span key={campi_nomi[cont]} data-nome={campi_nomi[cont]}><img src={campi_foto[cont]} className="imgcampo selected" id={cont} alt={cp.nome} onClick={selezionaCampo} /></span>
                    }
                    setcampi(campi => [...campi, el])
                })
            })
            .catch(error => {
                console.error("Errore nel caricamento campi:", error);
                showAlert("Attenzione", "Errore nel caricamento campi", 2000);
            });
    }

    const selezionaCampo = (e) => {
        document.querySelectorAll(".imgcampo").forEach(img => {
            img.classList.remove("selected")
        })
        e.target.classList.toggle("selected")
        document.querySelector("#campoNomeScelto").textContent = e.target.parentElement.dataset.nome
        confermaCampo()
    }

    const confermaCampo = () => {
        setCampo(document.querySelector(".selected").alt);
        aggiorna_orari(parseInt(document.querySelector(".selected").id))
        creaGiorniTitoli();
        document.querySelector("#sceltaCampi").style.opacity = "0";
        setcaricato(false);
        setTimeout(() => {
            document.querySelector("#sceltaCampi").style.display = "none";
            document.querySelector("#campoScelto").style.display = "flex";
            document.querySelector("#tabella-cont").style.display = "flex";
        }, 300);
    }

    const aggiorna_orari = (campo_id) => {
        setorari([])
        set_info_ore_stringa([])

        fetchWithAuth("visualizza_campi.php", {}, "GET")
            .then(function (data) {
                let ore_campo = data.campi[campo_id].fascia_oraria.split(",")
                const nuoviOrari = []
                let j = 0

                ore_campo.forEach((ora, i) => {
                    if (i !== ore_campo.length - 1) {
                        let fascia = '';
                        if(campo_id === 1) // TOUCHTENNIS
                            fascia = 'bianca';
                        else if (parseInt(ora) >= 17)
                            fascia = 'grigia';
                        else 
                            fascia = 'bianca';

                        const or = {
                            start: formattaOra(ora),
                            end: formattaOra(ore_campo[i + 1]),
                            fascia
                        }

                        nuoviOrari.push(or)
                        set_info_ore_stringa(prev => [
                            ...prev,
                            `${formattaOra(ora)} - ${formattaOra(ore_campo[i + 1])}`
                        ])
                    }

                    if (j === ore_campo.length - 1) {
                        creaGiorniTabella(num_giorni_visualizzati, ore_campo.length)
                    } else {
                        j++
                    }
                });

                setorari(nuoviOrari)
            });
    }

    // #endregion CAMPI

    const creaGiorniTitoli = () => {
        setgiorniTitoli([])
        set_info_mesi_numero([])
        set_info_giorni_stringa([])
        set_info_anni([])

        const nuoviMesi = [];
        const nuoviGiorniStringa = [];
        const nuoviAnni = [];

        document.querySelector("#giorni").style.gridTemplateColumns = "repeat(" + num_giorni_visualizzati + ",90px)"

        let mese_attuale = data_oggi.getMonth() + 1;
        let n_giorno = data_oggi.getDate();
        let num_giorni_mese = mesi[data_oggi.getMonth()].numero_giorni;
        let j = nomi_giorni.indexOf(data_oggi.toLocaleDateString("it-IT", { weekday: 'short' }).slice(0, 3));
        let anno = data_oggi.getFullYear()

        const nuoviGiorniTitoli = [];

        for (let i = 0; i < num_giorni_visualizzati; i++) {
            if (n_giorno === num_giorni_mese + 1) {
                n_giorno = 1;
                if (mese_attuale === 12) {
                    mese_attuale = 1;
                    anno += 1;
                } else {
                    mese_attuale += 1;
                }
            }

            const giornoStringa = i === 0 ?
                `${n_giorno} ${nomi_giorni[j]} oggi` :
                `${n_giorno} ${nomi_giorni[j]}`;

            const el =
                <div className={`giorno titolo`}
                    key={i + 'titolo'}>
                    <span>{n_giorno}</span>
                    <span>{nomi_giorni[j]}</span>
                </div>

            nuoviGiorniStringa.push(giornoStringa);
            nuoviMesi.push(mese_attuale);
            nuoviAnni.push(anno);

            nuoviGiorniTitoli.push(el)

            n_giorno += 1;
            j += 1;
            if (j === nomi_giorni.length) {
                j = 0;
            }
        }

        set_info_giorni_stringa(nuoviGiorniStringa);
        set_info_mesi_numero(nuoviMesi);
        set_info_anni(nuoviAnni);

        setgiorniTitoli(nuoviGiorniTitoli)
    }

    const creaGiorniTabella = (giorni, num_orari) => {
        riceviPrenotazioni("tutte", null, null)
    }

    const processaGiorniTabella = (params) => {
        const { n, num_orari } = params;

        try {
            // Filtra prenotazioni per il campo selezionato
            const prenotazioniCampo = prenotazioni.filter(p =>
                p.nomeCampo === campo && p.username !== "aaaaa"
            );

            const nuoviGiorniTabella = [];

            for (let ind_orario = 0; ind_orario < num_orari - 1; ind_orario++) {
                for (let ind_giorno = 0; ind_giorno < n; ind_giorno++) {
                    const info = dati_giorni_tabella(ind_giorno, ind_orario);

                    // Cerca prenotazione per questo giorno e ora
                    const prenotazioneEsistente = prenotazioniCampo.find(p => {
                        const giornoPren = parseInt(p.data.split("/")[0]);
                        const mesePren = parseInt(p.data.split("/")[1]);

                        return giornoPren === info.giorno_num &&
                            mesePren === info.mese_num &&
                            p.start === info.start &&
                            p.end === info.end;
                    });

                    let elemento;

                    if (prenotazioneEsistente) {
                        // Crea oggetto Giorno per prenotazione esistente

                        let disabled = utente_user.persona.username == "maestro1" ? false : true;

                        const giornoPrenotato = new Giorno(
                            prenotazioneEsistente.id,
                            prenotazioneEsistente.data,
                            prenotazioneEsistente.ora,
                            info.start,
                            info.end,
                            prenotazioneEsistente.fascia,
                            prenotazioneEsistente.username,
                            prenotazioneEsistente.inagibile,
                            prenotazioneEsistente.nome,
                            prenotazioneEsistente.cognome,
                            info.giorno_stringa,
                            disabled
                        );

                        elemento = creaElementoGiorno(giornoPrenotato);
                    } else {
                        // Crea oggetto Giorno per slot libero
                        let disabled = false;
                        if (info.giorno_stringa != undefined) {
                            if (info.giorno_stringa.includes("oggi") && info.ora_pren_num <= data_oggi.getHours())
                                disabled = true;
                        }

                            // Calcola la fascia dello slot (tenendo conto del weekend)
                        let fasciaSlot = "";
                        const orarioMatch = orari.find(o => o.start === info.start && o.end === info.end);
                        if (orarioMatch) fasciaSlot = orarioMatch.fascia;
                        if (info.giorno_stringa && (info.giorno_stringa.includes("sab") || info.giorno_stringa.includes("dom")) || campo === "TOUCHTENNIS") {
                            fasciaSlot = "bianca";
                        }

                        const giornoLibero = new Giorno(
                            null,
                            info.data_stringa,
                            info.ora_stringa,
                            info.start,
                            info.end,
                            fasciaSlot,
                            "",
                            false,
                            "",
                            "",
                            info.giorno_stringa,
                            disabled
                        );

                        elemento = creaElementoGiorno(giornoLibero);
                    }

                    nuoviGiorniTabella.push(elemento);
                }
            }

            setgiorniTabella(nuoviGiorniTabella);
            setcaricato(true);
        }
        catch {
            showAlert("Attenzione", "Si è verificato un errore.", 1000);
        }
    }

    const creaElementoGiorno = (giorno) => {
        if (giorno.disabled || giorno.username !== '') {
            let displayName = "Prenota";

            if (giorno.inagibile) {
                displayName = "C. Inagibile";
            } else if (giorno.username) {
                // Formatta il nome per display
                if (giorno.giocatore2 === "maestro1" || giorno.giocatore3 === "maestro1" || giorno.giocatore4 === "maestro1") {
                    displayName = "Maestro1";
                } else if (giorno.giocatore2 === "maestro2" || giorno.giocatore3 === "maestro2" || giorno.giocatore4 === "maestro2") {
                    displayName = "Maestro2";
                } else if (giorno.giocatore2 === "maestro3" || giorno.giocatore3 === "maestro3" || giorno.giocatore4 === "maestro3") {
                    displayName = "Maestro3";
                } else if (giorno.nome && giorno.cognome) {
                    displayName = `${giorno.nome[0].toUpperCase()}. ${giorno.cognome}`;
                } else {
                    displayName = giorno.username;
                }
            }

            return (
                <input type="button"
                    className={`disabled ${giorno.inagibile ? "inagibile" : "btn"} ${giorno.fascia}`}
                    disabled={giorno.disabled}
                    name="prenota"
                    value={displayName}
                    onClick={() => giorno_click(giorno)}
                    key={`${giorno.ora}-${giorno.data}`} />
            );
        } else {
            return (
                <input type="button"
                    className={`giorno_tab ${giorno.fascia}`}
                    disabled={giorno.disabled}
                    name="prenota"
                    value="Prenota"
                    data-data={`${giorno.ora}-${giorno.data}`}
                    onClick={() => giorno_click(giorno)}
                    key={`${giorno.ora}-${giorno.data}`} />
            );
        }
    }

    const dati_giorni_tabella = (ind_giorno, ind_orario) => {
        let giorno_stringa = info_giorni_stringa[ind_giorno]
        let num_mese = info_mesi_numero[ind_giorno]
        let ora_stringa = info_ore_stringa[ind_orario]
        let anno = info_anni[ind_giorno]

        let data_stringa = formattaData(parseInt(giorno_stringa), num_mese, anno);

        let ora_pren = ""
        try {
            ora_pren = ora_stringa.split(" - ")[1]
        } catch (error) {
            if (debug_mode) console.error(error)
        }
        let ora_pren_num = parseInt(ora_pren)
        let giorno_num = parseInt(giorno_stringa)
        let mese_num = parseInt(num_mese);

        let start = ora_stringa.split(" - ")[0]
        let end = ora_stringa.split(" - ")[1]

        return {
            giorno_stringa,
            num_mese,
            ora_stringa,
            anno,
            data_stringa,
            ora_pren,
            ora_pren_num,
            giorno_num,
            mese_num,
            start,
            end
        };
    }

    const riceviPrenotazioni = async (tipo, callback = null, param = null) => {
        try {
            let url = tipo === "singola" ?
                "visualizza_prenotazione.php" :
                "visualizza_prenotazioni.php";

            const data = await fetchWithAuth(url, {}, "GET");

            if (data.prenotazioni && data.prenotazioni.length > 0) {
                // Converti i dati in oggetti Prenotazione
                const prenotazioniObj = data.prenotazioni.map(p =>
                    new Prenotazione(
                        p.IDPrenota,
                        p.IDCampo,
                        p.IDUtente,
                        p.data,
                        p.ora,
                        p.start,
                        p.end,
                        p.timestamp,
                        p.fascia,
                        p.giocatore2,
                        p.giocatore3,
                        p.giocatore4,
                        p.giocatore2 == "inagibile",
                        p.nome,
                        p.cognome,
                        p.username,
                        p.campo_nome || p.nomeCampo,
                        p.puo_cancellare
                    )
                );

                if (debug_mode) console.log(prenotazioniObj);

                setPrenotazioni(prenotazioniObj);
                mostraPrenotazioniPopup(prenotazioniObj);
            } else {
                mostraPrenotazioniPopup([]);
                setPrenotazioni([]);
            }

            if (callback !== null && param !== null) {
                callback(param);
            }
        } catch (error) {
            console.error("Errore nel caricamento prenotazioni:", error);
            mostraPrenotazioniPopup([]);
            setPrenotazioni([]);

            if (callback !== null && param !== null) {
                callback(param);
            }
        }
    }

    const mostraPrenotazioniPopup = (data) => {
        const filtro = filtroPrenotazioni.trim().toLowerCase();

        let no_pren = true
        setprenotazioniPopup([])
        let m_temp = []
        let cont = 0
        let mettere_eti = true

        const nuoviElementi = []

        data.forEach(pren => {
            let pren_vecchia = false
            let gio = calcola_diff_giorni(data_oggi, "oggi", pren.data)
            if (gio < 0) {
                pren_vecchia = true
            }

            if (!pren_vecchia) {
                if (filtro) {
                    const testoRicerca = [
                        pren.data,
                        pren.username,
                        pren.giocatore2,
                        pren.giocatore3,
                        pren.giocatore4
                    ]
                        .filter(Boolean)
                        .join(" ")
                        .toLowerCase();

                    if (!testoRicerca.includes(filtro)) {
                        return;
                    }
                }

                let m = parseInt(pren.data.split("/")[1])
                let eti = <h3 data-month={m} key={m + Math.random()} className={mesi[m - 1].nome_mese}>{mesi[m - 1].nome_mese}</h3>

                if (m_temp.indexOf(m) === -1) {
                    m_temp.push(m)
                    mettere_eti = true
                } else {
                    mettere_eti = false
                }

                let el =
                    <div className={`prenotazione ${pren.inagibile ? "inagibile" : "normale"}`} key={pren.id} data-id={pren.id} data-data={pren.data} data-user={pren.username} data-ora={pren.ora} data-campo={pren.nomeCampo}>
                        <div className='campi-pren'>
                            <div className='campo-pren'>
                                <span>Username:</span><span>{pren.username}</span>
                            </div>
                            <div className='campo-pren'>
                                <span>Data:</span><span>{pren.data}</span>
                            </div>
                            <div className='campo-pren'>
                                <span>Ora:</span><span>{pren.ora}</span>
                            </div>
                            <div className='campo-pren'>
                                <span>Giocatori:</span>
                                <span>{pren.username}</span>
                                {pren.giocatore2 && (pren.giocatore2 != "aaaaa" && pren.giocatore2 != "ospite.ospite" && pren.giocatore2 != "inagibile") && <span>{pren.giocatore2}</span>}
                                {pren.giocatore3 && (pren.giocatore3 != "aaaaa" && pren.giocatore3 != "ospite.ospite") && <span>{pren.giocatore3}</span>}
                                {pren.giocatore4 && (pren.giocatore4 != "aaaaa" && pren.giocatore4 != "ospite.ospite") && <span>{pren.giocatore4}</span>}
                            </div>
                            <div className='campo-pren'>
                                <span>Campo:</span><span>{pren.nomeCampo}</span>
                            </div>
                            <div className='campo-pren'>
                                <span>Prenotato:</span><span>{new Date(pren.timestamp).toLocaleDateString('it-IT')}</span>
                            </div>
                        </div>
                        {Number(pren.puo_cancellare) === 1 && (
                            <i
                                className="fa-solid fa-trash-can"
                                data-month={m}
                                data-data={pren.data}
                                data-ora={pren.ora}
                                onClick={cancellaPren}
                            ></i>
                        )}
                    </div>

                if (mettere_eti || cont === 0) {
                    nuoviElementi.push(eti, el)
                } else {
                    nuoviElementi.push(el)
                }
                no_pren = false
                cont++
            }
        })

        if (no_pren || cont === 0) {
            setprenotazioniPopup([<h1 key={Math.random()} style={{ userSelect: "none", textAlign: "center" }}>Non ci sono prenotazioni</h1>])
        } else {
            setprenotazioniPopup(nuoviElementi)
        }
    }

    const giorno_click = (giorno) => {
        setGiornoSelezionato(giorno);
    }

    const controllaPrenotazioniEGiorno = (giorno) => {
        let appari = true
        let socio = utente_user.persona.socio
        let maestro = utente_user.persona.maestro

        if (!maestro) {
            if (!socio) {
                let parts = giorno.data.split("/");
                let data2 = new Date(parts[2], parts[1] - 1, parts[0]);
                let diffTime = Math.abs(data2 - data_oggi);
                let diffGiorni = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

                if (diffGiorni > 2) {
                    showAlert("Attenzione", "Non sei socio, puoi prenotare solo fino a 2 giorni di distanza", 2000)
                    appari = false
                }
            }
        }

        if (appari) {
            apriPopupPrenotazione(giorno)
        }
    }

    const prenotazione = async (campo_inagibile = false) => {
        document.querySelectorAll(".conf_btn").forEach((btn) => {
            btn.disabled = true
        })

        let fascia = ""

        if(campo == "TOUCHTENNIS")
            fascia = "bianca";
        else {
            orari.forEach((o) => {
                if (o.start === giornoSelezionato.start && o.end === giornoSelezionato.end)
                    fascia = o.fascia

                // Sabato e domenica sempre fascia bianca
                if (giornoSelezionato.giornoStringa.includes("sab") || giornoSelezionato.giornoStringa.includes("dom") || campo == "TOUCHTENNIS") {
                    fascia = "bianca"
                }
            })
        }

        await eseguiPrenotazione(fascia, campo_inagibile)
    }

    const eseguiPrenotazione = async (fascia, campo_inagibile) => {
        // Costruzione oggetto prenotazione
        let payload = {
            nomecampo: campo,
            data: giornoSelezionato.data,
            ora: `${giornoSelezionato.start},${giornoSelezionato.end}`,
            fascia: fascia,
            giocatore2: player,
            giocatore3: null,
            giocatore4: null
        };

        // Gestione tipologia di prenotazione (Inagibile / Ospite / Normale)
        if (campo_inagibile) {
            payload.giocatore2 = "inagibile";
        }
        else if (ospite.current?.checked) {
            // Se è un ospite, il giocatore loggato diventa il "secondo giocatore"
            // per permettere al backend di validare l'identità
            payload.giocatore2 = utente_user.persona.username;
        }
        else {
            // Prenotazione standard: verifichiamo che il giocatore sia stato selezionato
            if (player === "") {
                showAlert("Attenzione", "Seleziona un giocatore", 1600);
                // Riabilita i pulsanti in ogni caso
                    document.querySelectorAll(".conf_btn").forEach(btn => btn.disabled = false);
                return;
            }
            payload.giocatore2 = player.toLowerCase();
        }

        // Disabilita pulsanti per evitare doppi click
        document.querySelectorAll(".conf_btn").forEach(btn => btn.disabled = true);

        try {
            // 4. Invio al server
            // Il server ora esegue checkUserCanBook internamente per ogni giocatore
            const data = await fetchWithAuth("prenota_campo.php", {
                method: "POST",
                body: JSON.stringify(payload)
            });

            if (data.ok) {
                showAlert("Successo!", "Prenotazione effettuata!", 1600);
                // Reset stato locale
                setPlayer("");
                if (inputPlayer.current) inputPlayer.current.reset();

                // Chiudi il popup e rinfresca la tabella
                chiudi_pren();
                riceviPrenotazioni("tutte");
            } else {
                // Qui riceverai l'errore specifico (es: "Blocco per mario.rossi: Certificato scaduto")
                showAlert("Attenzione", data.error || "Errore nella prenotazione", 2000);
            }
        } catch (error) {
            console.error("Errore nella prenotazione:", error);
            showAlert("Attenzione", "Errore di connessione al server", 1600);
        } finally {
            // Riabilita i pulsanti in ogni caso
            document.querySelectorAll(".conf_btn").forEach(btn => btn.disabled = false);
        }
    };

    const cancellaPren = async (e) => {
        try {
            const data = await fetchWithAuth("cancella_prenotazione.php", {
                body: JSON.stringify({ "idprenota": e.target.parentElement.dataset.id })
            });

            if (data.ok) {
                try {
                    e.target.parentElement.style.display = "none"
                    if (document.querySelectorAll("[data-month='" + e.target.dataset.month + "']").length - 2 === 0) {
                        document.querySelector("h3[data-month='" + e.target.dataset.month + "']").style.display = "none"
                    }
                    e.target.dataset.month = "-1"
                    let conta = 0
                    document.querySelectorAll("#pren-cont *").forEach((pren) => {
                        if (pren.style.display === "none") {
                            conta++
                        }
                    })
                    if (e.target.parentElement.parentElement.children.length === conta) {
                        setprenotazioniPopup([<h1 key={Math.random()} style={{ userSelect: "none", textAlign: "center" }}>Non ci sono prenotazioni</h1>])
                    }
                } catch (error) {
                    console.error("Errore UI:", error);
                }
            } else {
                showAlert("Attenzione", data.error || "Errore nella cancellazione");
            }
        } catch (error) {
            console.error("Errore nella cancellazione:", error);
            showAlert("Attenzione", "Errore nella cancellazione");
        }
    }

    // #region OPEN/CLOSE POPUPS

    const apriPopupPrenotazione = (giornoData) => {
        document.querySelector("#giorno-pren").textContent = giornoData.giornoStringa
        document.querySelector("#ora-pren").textContent = giornoData.ora
        document.querySelector("#popup-prenota").classList.remove("chiuso")
        document.querySelectorAll(".conf_btn").forEach((el) => {
            el.disabled = false
        })
        if (utente_user.persona.maestro) {
            // player = "aaaaa"
            setPlayer("aaaaa");
            inputPlayer.current.setValue("aaaaa");
        }
    }

    const popup_vedi_pren = (tipo) => {
        setFiltroPrenotazioni("");
        document.querySelector("#popup-vedi-pren").classList.remove("chiuso");
        document.querySelector("#tutte_pren").disabled = true;
        riceviPrenotazioni(tipo);
    }

    const chiudi_vedi_pren = () => {
        setFiltroPrenotazioni("");
        document.querySelector("#popup-vedi-pren").classList.add("chiuso")
        document.querySelector("#tutte_pren").disabled = false
        setprenotazioniPopup([])
        setTimeout(() => {
            creaGiorniTabella(num_giorni_visualizzati, document.querySelectorAll(".orar").length + 1)
        }, 400)
    }

    const chiudi_pren = () => {
        inputPlayer.current.reset();
        // player = "";
        setPlayer("");
        document.querySelector("#popup-prenota").classList.add("chiuso")
        setTimeout(() => {
            creaGiorniTabella(num_giorni_visualizzati, document.querySelectorAll(".orar").length + 1)
        }, 400)
    }

    const apri_info = () => {
        document.querySelector("#informazioni").classList.remove("chiuso")
    }

    // #endregion OPEN/CLOSE POPUPS

    const cambiaCampo = () => {
        // Nasconde la sezione del campo scelto e tabella
        document.querySelector("#campoScelto").style.display = "none";
        document.querySelector("#tabella-cont").style.display = "none";

        // Mostra la selezione campi
        const sceltaCampi = document.querySelector("#sceltaCampi");
        sceltaCampi.style.display = "flex";
        setTimeout(() => {
            sceltaCampi.style.opacity = "1";
        }, 50);

        // Reset dello stato campo e orari
        setCampo("CAMPO1");
        setorari([]);
        setgiorniTitoli([]);
        setgiorniTabella([]);
    }

    return (
        <>
            <Helmet>
                <title>Sporting - Prenota</title>
                <meta
                    name="description"
                    content="Prenota un campo da Sporting Saluzzo!"
                />
            </Helmet>

            <div id="prenota">
                {!caricato ? <h1 style={{ textAlign: "center", marginTop: "50px" }}>Caricamento...</h1> : null}
                <Popup id="popup-prenota" onClose={chiudi_pren} title="Prenota">
                    <div id='info-pren'>
                        <div id="giorno-pren">
                            1 gio
                        </div>
                        <div id="ora-pren">
                            8:00
                        </div>
                    </div>
                    <p style={{ fontSize: 18, paddingLeft: 20, paddingRight: 20, margin: 10, textAlign: "center" }}>
                        Se è la prima volta che prenoti, prima di farlo sei pregato di contattarci al numero <a style={{ fontSize: 18, color: "#2f4550", fontWeight: "bold" }} href='tel:+393334363911'>+39 333 436 3911</a>
                    </p>
                    <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
                        {utente_user.persona.maestro && <input style={{ marginTop: 15, marginBottom: 10 }} type="button" name="inagibile" id="campo_inagibile" className="conf_btn" value="Campo Inagibile" onClick={() => prenotazione(true)} />}
                        <input style={{ marginTop: 15, marginBottom: 10 }} type="button" name="conf" id="conferma" className="conf_btn" value="Prenota" onClick={() => prenotazione(false)} />
                    </div>
                    {utente_user.persona.maestro && <div id="cont-check">
                        <div className="check-doppio" style={{ margin: 15 }}>
                            <span><input type="checkbox" ref={ospite} id='ospite' name="doppio" value="Doppio" /></span>
                            <label>Prenota per ospite</label>
                        </div>
                    </div>}
                    <h2 style={{ marginBottom: "20px", textAlign: "center" }}>Seleziona l'altro giocatore:</h2>
                    <div id="giocatori">
                        <InputSelect ref={inputPlayer} elementi={usernames_players_list.map((x) => x.username)} onSelect={(nome) => setPlayer(nome)} />
                    </div>
                </Popup>

                <Popup id="popup-vedi-pren" title="Prenotazioni" onClose={chiudi_vedi_pren} >
                    <div className="search-pren">
                        <input type="text"
                            placeholder="Cerca per data o username"
                            value={filtroPrenotazioni}
                            onChange={(e) => setFiltroPrenotazioni(e.target.value)}
                            style={{
                                width: "100%",
                                padding: "10px",
                                borderRadius: "8px",
                                backgroundColor: "#eaeaea",
                                boxSizing: "border-box",
                                cursor: "initial",
                                outline:"none",
                                color:"black"
                            }}
                        />
                    </div>
                    <div id="pren-cont">
                        {prenotazioniPopup}
                    </div>
                </Popup>

                <div id="no-accesso" ref={NoAccesso}>
                    Effettua l'accesso per prenotare
                </div>
                {
                    caricamentoUtente &&
                    <div style={{ textAlign: "center", marginTop: "20px", fontWeight: "bold" }}>
                        Caricamento utente...
                    </div>
                }
                <div id="sceltaCampi">
                    <h1>Seleziona il campo</h1>
                    <div id="campi-img">
                        {campi}
                    </div>
                </div>
                <div id="campoScelto">
                    <div id="info_btn" onClick={apri_info} style={{ display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", width: "220px", textAlign: "center" }}>
                        <i className="fa-solid fa-circle-info" style={{ marginRight: "10px" }}></i>
                        <span style={{ color: "var(--text)" }}>Informazioni</span>
                    </div>
                    <div>
                        <div id="campoNomeScelto">
                            Campo 1
                        </div>

                        <div id="campoNomeScelto" onClick={cambiaCampo} style={{ cursor: "pointer" }}>
                            <span id="nome" style={{ userSelect: "none" }}>Cambia campo</span>
                        </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                        <input type="button" name="" id="tutte_pren" value="Tutte le prenotazioni" onClick={() => { popup_vedi_pren("tutte") }} style={{ width: "230px", marginBottom: "10px" }} />
                        <input type="button" name="" id="mie_pren" value="Le tue prenotazioni" onClick={() => { popup_vedi_pren("singola") }} />
                    </div>
                </div>
                <Informazioni />
                <div id="tabella-cont">
                    <div id="tabella">
                        <div id="orari">
                            <div className='titolo'>
                                Orari
                            </div>
                            {orari.map(o => (
                                <div key={o.start} className={`orar ${o.fascia}`}>
                                    {o.start} - {o.end}
                                </div>
                            ))}
                        </div>
                        <div id="giorni">
                            {giorniTitoli}
                            {giorniTabella}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Prenota